/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Difficulty level for Bloom taxonomy steering
 */
export type AssessmentDifficulty = (typeof AssessmentDifficulty)[keyof typeof AssessmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssessmentDifficulty = {
  foundational: 'foundational',
  advanced: 'advanced',
  expert: 'expert',
} as const;
